<template>
  <div>
    <table-view
      ref="tableList"
      :tableModel="tableModel"
      :tableData="tableData"
      :searchModel="searchModel"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="CSS REPORTS LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          @click="handleDownload(tableRow.row)"
          v-if="tableRow.row.status === 1"
        >
          Download
        </a>
      </template>
    </table-view>
    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="462px"
      @close="handleCancel"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="Report Type" prop="type">
            <el-select
              v-model="form.type"
              style="width: 100%"
              @change="handleTypeChange"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="
              form.type === 3
                ? 'Expiry Date'
                : form.type === 6
                ? 'Decision Date'
                : form.type === 5
                ? 'TnC Expiry Date'
                : 'Expiry Date'
            "
          >
            <template
              v-if="form.type == 3 || form.type == 5 || form.type === 8"
            >
              <el-date-picker
                style="width: 100%"
                v-model="form.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                key="single_date"
              />
            </template>
            <template v-else>
              <el-date-picker
                style="width: 100%"
                v-model="form.startDate"
                type="daterange"
                range-separator="-"
                start-placeholder="start"
                value-format="yyyy-MM-dd"
                end-placeholder="end"
                key="single_double"
              />
            </template>
          </el-form-item>
          <el-form-item label="TnC Active" prop="active" v-if="form.type === 5">
            <el-select v-model="form.active" style="width: 100%">
              <el-option label="Yes" value="1" />
              <el-option label="No" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item
            label="Geo"
            prop="geo"
            v-if="form.type === 3 || form.type === 8 || form.type === 5"
          >
            <el-select v-model="form.geo" style="width: 100%" multiple>
              <el-option
                v-for="item in GeoList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button
          class="clear-btn"
          style="margin-right: 20px"
          @click="handleCancel"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, download, add } from './api'
import { getSelectList } from '@/api'
import dayjs from 'dayjs'

export default {
  data() {
    this.typeList = [
      {
        id: 3,
        name: 'CSS Collateral Report',
      },
      {
        id: 5,
        name: 'CSST T&Cs Report',
      },
      {
        id: 6,
        name: 'Weekly Activity Testing',
      },
      {
        id: 8,
        name: 'Portfolio Quality Report',
      },
    ]
    const searchModel = [
      {
        label: 'Report Type',
        type: 'select',
        key: 'type',
        selectList: this.typeList,
      },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          { id: 0, name: 'In Processing' },
          { id: 1, name: 'Success' },
          { id: 2, name: 'Failure' },
        ],
      },
    ]
    const tableModel = [
      {
        label: 'Report Type',
        prop: 'typeStr',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'Submitted By',
        prop: 'username',
      },
      {
        label: 'Status',
        prop: 'statusStr',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        type: 3,
        startDate: '',
        geo: [],
        active: '',
      },
      rules: {
        startDate: [
          {
            required: true,
            message: 'Please enter the time.',
            trigger: 'blur',
          },
        ],
      },
      GeoList: [],
      RegionList: [],
      SalesCountryList: [],
      BUList: [],
      BusinessList: [],
    }
  },
  mounted() {
    this.initTable()
    this.getSelectList_()
  },
  computed: {},
  methods: {
    handleTypeChange(type) {
      this.form.type = type
      if (type == 5 || type === 8) {
        this.form.startDate = dayjs().format('YYYY-MM-DD')
      } else {
        this.form.startDate = ''
      }
      this.form.geo = []
    },
    async getSelectList_() {
      this.GeoList = await getSelectList({ typeMark: 'Geo' })
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleCancel() {
      this.visible = false
      this.form = {
        type: 3,
        startDate: '',
        geo: [],
      }
      this.fileList = []
    },
    async handleSaveBtn() {
      try {
        if (!this.form.startDate && ![3, 5].includes(this.form.type)) {
          this.$message.warning('Please choose Date.')
          return false
        }
        await add(this._filterData({ ...this.form }))
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (e) {
        console.error(e)
      }
    },
    _filterData(data) {
      const result = { ...data }
      result.geo = result.geo.join()
      if (result.type == 5 || result.type === 8) {
        if (result.type == 5) {
          result.startDate = this.form.startDate || '1933-09-20'
          return result
        }
        result.endDate = '2099-12-31'
      } else if (result.type === 3) {
        result.startDate = this.form.startDate || '1933-09-20'
        result.endDate = '2099-12-31'
      } else {
        result.endDate = dayjs(result.startDate[1])
          .subtract(-1, 'day')
          .format('YYYY-MM-DD')
        result.startDate = result.startDate[0]
      }
      return result
    },

    async handleTitleActionBtn() {
      this.visible = true
    },
    handleChange(file) {
      if (file.response) return
      if (this.fileList.length < 5) {
        this.fileList.push(file)
      }
    },
    async handleDownload({ fileUrl, fileName }) {
      try {
        await download({
          url: fileUrl,
          fileName,
        })
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
  },
}
</script>
